<template>
  <div>
    <!-- <div class="topbar" v-if="canListSupporter"> -->
    <div class="topbar">
      <SupporterSearch class="search" @click="navigateToSupporterDetail" @searching="searching" />

      <!-- <div class="left">
        <h1>{{ title }}</h1>
      </div> -->

      <div class="flex-grow"></div>
      <!-- <div v-if="canCreateDonation"> -->
      <div>
        <button @click="showDonationModal()" style="white-space: nowrap">New Supporter</button>
      </div>
    </div>
    <DonationModal v-if="isDonationModalDisplayed" />
  </div>
</template>

<script>
import DonationModal from '@/components/DonationModal/Main.vue';
import SupporterSearch from '@/modules/supporters/views/SupporterSearch.vue';

export default {
  name: 'topbar',
  components: {
    DonationModal,
    SupporterSearch,
  },

  data() {
    return {
      view: null,
      isSearching: false,
    };
  },
  watch: {
    search: function (value) {
      console.log(value);
    },
  },
  props: {
    title: String,
  },
  computed: {
    isDonationModalDisplayed: function () {
      return this.$store.getters['donationModal/isDisplayed'];
    },
    // canCreateDonation() {
    //   return this.$store.getters['auth/hasAccess'](MODULE.SUPPORTER, PERMISSION.CREATE) && !this.isSearching;
    // },
    // canListSupporter() {
    //   return this.$store.getters['auth/hasAccess'](MODULE.SUPPORTER, PERMISSION.LIST);
    // },
  },

  methods: {
    searching(value) {
      this.isSearching = value;
    },
    showDonationModal() {
      const isDisplayed = this.$store.getters['donationModal/isDisplayed'];
      this.$store.commit('donationModal/updateAddDonation', false);
      if (!isDisplayed) {
        this.$store.dispatch('donationModal/open');
      }
    },
    navigateToSupporterDetail(supporter) {
      if (!this.$route.params.id || supporter.id.toString() !== this.$route.params.id.toString()) {
        this.$router.push({ name: 'supporter-view', params: { id: supporter.id } });
      }
    },
  },
};
</script>

<style>
.topbar {
  border-bottom: 1px solid #e5e7eb;
}

.supporters-search {
  box-shadow: none !important;
}
</style>
